/* unplugin-vue-components disabled */import { render } from "./QuizReadonlyAlert.vue?vue&type=template&id=57fe1838&scoped=true&ts=true"
import script from "./QuizReadonlyAlert.vue?vue&type=script&lang=ts"
export * from "./QuizReadonlyAlert.vue?vue&type=script&lang=ts"

import "./QuizReadonlyAlert.vue?vue&type=style&index=0&id=57fe1838&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57fe1838"]])

export default __exports__